require([
    "common/linkUrlTokenReplacer"
],
function (replacer) {
    replacer.replaceTokens(".links-menu");
    // copy the contents of Links Menu component into the mobile menu
    var linksMenuElement = $("#menu-wrapper .links-menu")[0];
    if (linksMenuElement) {
        $("#menu-wrapper .mob-menu").append(linksMenuElement.outerHTML);
    }
});

define("LinksMenu/main", function(){});

